export default __webpack_public_path__ + "static/media/img-9091.8165368a.png";